import { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useDevice } from '@atc/react-device';
import { SideBarToModal } from 'reaxl';
import OfferBreakdown from '../OfferBreakdown/OfferBreakdown.js';
import ConfigContext from '../ConfigContext/ConfigContext.js';
import { jsx } from 'react/jsx-runtime';
function OfferBreakdownModal(_ref) {
  let {
    container,
    isVisible = false,
    adjustedCapCost,
    downPayment,
    renderTaxesAndFees,
    tabName = 'finance',
    totalCashOut,
    totalFinancing,
    offerBreakdownProps = {},
    onHide = () => {}
  } = _ref;
  const {
    disableIncentives = false,
    disableTrade = false,
    enableOfferUpgrades = true,
    enablePriceDetailsInOfferBreakdown = true,
    showMsrp = true
  } = useContext(ConfigContext) ?? {};
  const device = useDevice();
  const isXs = device?.is?.xs ?? false;
  const {
    getPricingBreakdown
  } = offerBreakdownProps;
  const pricingDetail = getPricingBreakdown(tabName);
  if (!pricingDetail || _isEmpty(pricingDetail)) {
    return null;
  }
  return /*#__PURE__*/jsx(SideBarToModal, {
    container: container,
    title: "Offer Breakdown",
    content: /*#__PURE__*/jsx(OfferBreakdown, {
      adjustedCapCost: adjustedCapCost,
      disableIncentives: disableIncentives,
      disableTrade: disableTrade,
      downPayment: downPayment,
      enableOfferUpgrades: enableOfferUpgrades,
      enablePriceBreakdown: enablePriceDetailsInOfferBreakdown,
      renderTaxesAndFees: renderTaxesAndFees,
      showMsrp: showMsrp,
      tabName: tabName,
      totalCashOut: totalCashOut,
      totalFinancing: totalFinancing,
      isModal: true,
      ...offerBreakdownProps
    }),
    collapsed: isXs,
    show: isVisible,
    sideBarOptions: {
      fullWidth: true
    },
    modalOptions: {
      bsStyle: 'sm'
    },
    onHide: onHide
  });
}
export { OfferBreakdownModal as default };
